import { RoundedFilledButton, SecondaryButtonMT } from '@/components/buttons/Buttons';
import FullScreenModal from '@/components/modals/FullScreenModal';
import { type Dispatch, type SetStateAction, useState } from 'react';
import { MdAdd } from 'react-icons/md';
import AddItem from '../components/AddItem';
import BulkAddDialog from '../components/BulkAddDialog';
import { SingleAddDialogModal } from '../components/SingleAddDialog';
import './add-employee.styles.css';
import { GenericResponse, ListResponse, showTypedModal } from '@/common/common_utils';
import { ENDPOINTS } from '@/constants/endpoints';
import { axiosInstance } from '@/services/axios.service';
import { BaseResponse, X4bEmployeeListItem, OnboardingStep } from '@/types';
import { useQuery } from '@tanstack/react-query';
import NiceModal from '@ebay/nice-modal-react';
import { useOnboardingState } from '@/modules/onboarding/engine/onboarding.hooks';

type Props = {
	// visible: boolean;
	setVisible: Dispatch<SetStateAction<boolean>>;
};
export const AddEmployeeModal = NiceModal.create<Props>((props: Props) => {
	return (
		<AddEmployeeModalImpl {...props} />
	);
});

const AddEmployeeModalImpl = (props: Props) => {
	//const [visibleSingle, setVisibleSingle] = useState(false);
	const [visibleBulk, setVisibleBulk] = useState(false);
	const { completeStepMutation } = useOnboardingState();

	const peopleQuery = useQuery<ListResponse<X4bEmployeeListItem>>({
		queryKey: ['AddEmployeeModal.employees', visibleBulk],// filter - triggers query when setFilter is called.
		initialData: { Items: [], TotalRecords: 0 },
		queryFn: async () => {
			const result = await axiosInstance.post<GenericResponse<ListResponse<X4bEmployeeListItem>>>(
				ENDPOINTS['/api/X4bEmployee/GetEmployeeListForOnboarding'], {
				Skip: 0,
				Take: 100
			}
			);
			return result.data.Data;
		}
	});

	return (
		<FullScreenModal
			header="Add employee or a team"
			visible={true}
			setVisible={props.setVisible}
		>
			<p>
				Invite your employees or team members to join seamlessly through
				personalized invitations, offering two convenient methods for
				onboarding:
			</p>
			<ol className="employee-modal-list">
				<li>
					<span>Single Add:</span> Easily add individual team members
					by inputting their details directly.
				</li>
				<li>
					<span>Bulk Add:</span> Streamline the process by uploading a
					CSV file containing multiple employee profiles at once.
				</li>
			</ol>
			{peopleQuery.data?.Items.map((employee) => (
				<AddItem
					key={employee.Id} // Use a unique key, such as person.id
					item={employee}
					onEdit={async () => {
						await showTypedModal(SingleAddDialogModal, { Id: employee.Id });
						await peopleQuery.refetch();
					}
					}
					onDelete={async () => {
						await axiosInstance.post<BaseResponse>(
							ENDPOINTS['/api/X4bEmployee/DeleteEmployees'], [employee.Id]
						);
						await peopleQuery.refetch();
					}}
				/>
			))}

			<div className="panel-actions">
				<RoundedFilledButton
					id="employee-modal-add"
					label="Add"
					icon={MdAdd}
					onClick={async () => {
						await showTypedModal(SingleAddDialogModal, { Id: 0 });
						await peopleQuery.refetch();
					}
					}
				/>
				<SecondaryButtonMT
					id="employee-modal-bulk"
					label="Bulk Add"
					icon={<MdAdd />}
					className='!h-[48px]'
					onClick={() => {
						setVisibleBulk(true);
					}}
				/>
				<RoundedFilledButton
					id="employee-modal-skip"
					label="Skip"
					className="skip-button"
					onClick={async () => {
						await completeStepMutation.mutateAsync(OnboardingStep.InviteEmployees);
						props.setVisible(false);
					}}
				/>
			</div>

			{/* <SingleAddDialog
				onAdded={async () => {
					await peopleQuery.refetch();
				}}
			/> */}
			<BulkAddDialog
				visibleBulk={visibleBulk}
				setVisibleBulk={setVisibleBulk}
			/>
		</FullScreenModal>
	);
};

export default AddEmployeeModal;
// function useQuery(arg0: {
// 	queryKey: any[]; // filter - triggers query when setFilter is called.
// 	initialData: { Items: X4bEmployeeListItem[]; TotalRecords: number; }; queryFn: () => Promise<any>;
// }) {
// 	throw new Error('Function not implemented.');
// }

